import { useEffect } from 'react';
import { config } from '../../Config';
import Clarity from '@microsoft/clarity';

const ClarityConfig = ({ user, isPublic = false }) => {
  // Initialize Clarity
  useEffect(() => {
    try {
      const clarityProjectId = config.REACT_APP_CLARITY_PROJECT_ID;
      if (!clarityProjectId) {
        console.warn('Clarity Project ID is not defined in environment variables');
        return;
      }
      
      // Initialize Clarity
      Clarity.init(clarityProjectId);
    } catch (error) {
      console.error('>>>> ClarityConfig initialization error:', error);
    }
  }, []);

  // Set route-specific tags
  useEffect(() => {
    try {
      // Set basic route type tag
      Clarity.setTag("route_type", isPublic ? "public" : "authenticated");
      
      // For public routes, set basic tracking
      if (isPublic) {
        Clarity.setTag("page_url", window.location.pathname);
      }
    } catch (error) {
      console.error('>>>> ClarityConfig route tagging error:', error);
    }
  }, [isPublic]);

  // Identify and tag authenticated users
  useEffect(() => {
    try {
      if (user) {
        // Identify user
        Clarity.identify(
          user.ID || user.Email, // unique identifier
          user.Email, // session identifier (optional)
          undefined, // page identifier (optional)
          user.FullName || user.Email // friendly name (optional)
        );

        // Set user tags
        Clarity.setTag("email", user.Email);
        Clarity.setTag("name", user.FullName);
        Clarity.setTag("account_id", user.AccountID);
        Clarity.setTag("user_id", user.ID);
        Clarity.setTag("user_role", user.Role);

        // Set subscription status tags
        Clarity.setTag("subscription_status", user.SubscriptionStatus);
        Clarity.setTag("subscription_remaining_days", user.SubscriptionRemainingDays?.toString());

        // Set organization tags
        Clarity.setTag("organization_id", user.OrganizationID);
        Clarity.setTag("organization_name", user.OrgName);

      } 
    } catch (error) {
      console.error('>>>> ClarityConfig user identification error:', error);
    }
  }, [user, isPublic]);

  // Track page views
  useEffect(() => {
    try {
      const currentPath = window.location.pathname;
      Clarity.setTag("current_page", currentPath);
    } catch (error) {
      console.error('>>>> ClarityConfig page tracking error:', error);
    }
  }, [window.location.pathname]);

  return null; // This component doesn't render anything
};

export default ClarityConfig; 